import { ca } from '@cian/analytics';

import { EExtraVillages } from '../../constants/village';
import {
  IVillageSchema,
  IBreadcrumbSchema,
  TUser,
  IGetVillageResponseSchema,
  IRelatedVillageSchema,
} from '../../types';

export const getTrackingPageInfo = (village: IVillageSchema, breadcrumbs?: IBreadcrumbSchema[]) => ({
  breadCrumbs: breadcrumbs?.map(item => item.title),
  offerID: village.id,
  offerType: 'KP',
  pageType: 'CardKP',
  siteType: 'desktop',
});

export const getTrackingUserInfo = (user: TUser | undefined, abGroup: number) => ({
  abGroup,
  isAuthorized: (user && user.isAuthenticated) || false,
  userId: user && user.isAuthenticated ? user.id : undefined,
});

export const trackSimilarVillagesShow = (
  { village, breadcrumbs }: IGetVillageResponseSchema,
  user: TUser | undefined,
  abGroup: number,
  villages: IRelatedVillageSchema[],
  type: EExtraVillages,
) => {
  ca('eventEbc', {
    action: type === EExtraVillages.Nearby ? 'show_nearest_KP' : 'show_similar_KP',
    category: 'similar_objects',
    name: 'oldevent',
    label: '',
    page: getTrackingPageInfo(village, breadcrumbs),
    products: villages.map(({ id }, index) => ({
      id,
      offerType: 'KP',
      position: index + 1,
    })),
    user: getTrackingUserInfo(user, abGroup),
  });
};

export const trackSimilarVillageClick = (
  { village, breadcrumbs }: IGetVillageResponseSchema,
  user: TUser | undefined,
  abGroup: number,
  villageId: number,
  position: number,
  type: EExtraVillages,
) => {
  ca('eventEbc', {
    action: type === EExtraVillages.Nearby ? 'click_nearest_KP' : 'click_similar_KP',
    category: 'similar_objects',
    name: 'oldevent',
    label: '',
    page: getTrackingPageInfo(village, breadcrumbs),
    products: [
      {
        id: villageId,
        offerType: 'KP',
        position,
      },
    ],
    user: getTrackingUserInfo(user, abGroup),
  });
};
